import script from "./PsaOrdersWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./PsaOrdersWidget.vue?vue&type=script&setup=true&lang=js"

import "./PsaOrdersWidget.vue?vue&type=style&index=0&id=279f0b5a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279f0b5a"]])

export default __exports__